export default __webpack_public_path__ + "static/media/error-white.018b6b4f.svg";